
export default {
    name: "BillSignReceived",
	conditionData:'',
	mounted: function () {
       this.init();
	},
    data() {
        return {
            billSignReceivedForm: {
                // 邮寄信息id
                id: '',
                // 邮寄信息version
                version: '',
                // 提单文件信息
                billOfLadingExpressVos: []
            },
        }
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
        this.billSignReceivedForm = Object.assign({}, this.billSignReceivedForm, this.conditionData.row);
        console.log(this.billSignReceivedForm)
    },
    methods: {
		init(){
			this.conditionData = this.$routerUtil.getParam();
			this.$routerUtil.clearParam();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.billSignReceivedForm);
                    param.status = 1;
                    console.log(param);
                    this.$axios.put('api/billOfLadings/mailSign', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.doCancel();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
		doCancel(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('receipt-manage');
        }
    }
}
